import styled from "styled-components";

export const LobbyHeaderTitleDefaultBox = styled.h1`
  width: 100%;
  ${({theme}) => theme.font.presets.secondary};
  color: ${props => props.theme.colors.textLight};
  font-size: 3rem;

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    font-size: 2.2rem;
  }
`;
